import { Component } from '@angular/core';

@Component({
  selector: 'app-html-pdf-content',
  imports: [],
  templateUrl: './html-pdf-content.component.html',
  styleUrl: './html-pdf-content.component.css'
})
export class HtmlPdfContentComponent {

}
